"use strict";

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heartbeat = void 0;

var constants = __importStar(require("./constants"));

var get_gossip_peers_1 = require("./get-gossip-peers");

var utils_1 = require("./utils"); // eslint-disable-next-line @typescript-eslint/ban-ts-comment


var Heartbeat = /*#__PURE__*/function () {
  /**
   * @param {Object} gossipsub
   * @constructor
   */
  function Heartbeat(gossipsub) {
    _classCallCheck(this, Heartbeat);

    this.gossipsub = gossipsub;
  }

  _createClass(Heartbeat, [{
    key: "start",
    value: function start() {
      var _this = this;

      if (this._heartbeatTimer) {
        return;
      }

      var heartbeat = this._heartbeat.bind(this);

      var timeout = setTimeout(function () {
        heartbeat();

        _this._heartbeatTimer.runPeriodically(heartbeat, _this.gossipsub._options.heartbeatInterval);
      }, constants.GossipsubHeartbeatInitialDelay);
      this._heartbeatTimer = {
        _intervalId: undefined,
        runPeriodically: function runPeriodically(fn, period) {
          _this._heartbeatTimer._intervalId = setInterval(fn, period);
        },
        cancel: function cancel() {
          clearTimeout(timeout);
          clearInterval(_this._heartbeatTimer._intervalId);
        }
      };
    }
    /**
     * Unmounts the gossipsub protocol and shuts down every connection
     * @override
     * @returns {void}
     */

  }, {
    key: "stop",
    value: function stop() {
      if (!this._heartbeatTimer) {
        return;
      }

      this._heartbeatTimer.cancel();

      this._heartbeatTimer = null;
    }
    /**
     * Maintains the mesh and fanout maps in gossipsub.
     *
     * @returns {void}
     */

  }, {
    key: "_heartbeat",
    value: function _heartbeat() {
      var _this2 = this;

      var _this$gossipsub$_opti = this.gossipsub._options,
          D = _this$gossipsub$_opti.D,
          Dlo = _this$gossipsub$_opti.Dlo,
          Dhi = _this$gossipsub$_opti.Dhi,
          Dscore = _this$gossipsub$_opti.Dscore,
          Dout = _this$gossipsub$_opti.Dout,
          fanoutTTL = _this$gossipsub$_opti.fanoutTTL;
      this.gossipsub.heartbeatTicks++; // cache scores throught the heartbeat

      var scores = new Map();

      var getScore = function getScore(id) {
        var s = scores.get(id);

        if (s === undefined) {
          s = _this2.gossipsub.score.score(id);
          scores.set(id, s);
        }

        return s;
      }; // peer id => topic[]


      var tograft = new Map(); // peer id => topic[]

      var toprune = new Map(); // peer id => don't px

      var noPX = new Map(); // clean up expired backoffs

      this.gossipsub._clearBackoff(); // clean up peerhave/iasked counters


      this.gossipsub.peerhave.clear();
      this.gossipsub.iasked.clear(); // apply IWANT request penalties

      this.gossipsub._applyIwantPenalties(); // ensure direct peers are connected


      this.gossipsub._directConnect(); // maintain the mesh for topics we have joined


      this.gossipsub.mesh.forEach(function (peers, topic) {
        // prune/graft helper functions (defined per topic)
        var prunePeer = function prunePeer(id) {
          _this2.gossipsub.log('HEARTBEAT: Remove mesh link to %s in %s', id, topic); // update peer score


          _this2.gossipsub.score.prune(id, topic); // add prune backoff record


          _this2.gossipsub._addBackoff(id, topic); // remove peer from mesh


          peers.delete(id); // add to toprune

          var topics = toprune.get(id);

          if (!topics) {
            toprune.set(id, [topic]);
          } else {
            topics.push(topic);
          }
        };

        var graftPeer = function graftPeer(id) {
          _this2.gossipsub.log('HEARTBEAT: Add mesh link to %s in %s', id, topic); // update peer score


          _this2.gossipsub.score.graft(id, topic); // add peer to mesh


          peers.add(id); // add to tograft

          var topics = tograft.get(id);

          if (!topics) {
            tograft.set(id, [topic]);
          } else {
            topics.push(topic);
          }
        }; // drop all peers with negative score, without PX


        peers.forEach(function (id) {
          var score = getScore(id);

          if (score < 0) {
            _this2.gossipsub.log('HEARTBEAT: Prune peer %s with negative score: score=%d, topic=%s', id, score, topic);

            prunePeer(id);
            noPX.set(id, true);
          }
        }); // do we have enough peers?

        if (peers.size < Dlo) {
          var backoff = _this2.gossipsub.backoff.get(topic);

          var ineed = D - peers.size;
          var peersSet = get_gossip_peers_1.getGossipPeers(_this2.gossipsub, topic, ineed, function (id) {
            // filter out mesh peers, direct peers, peers we are backing off, peers with negative score
            return !peers.has(id) && !_this2.gossipsub.direct.has(id) && (!backoff || !backoff.has(id)) && getScore(id) >= 0;
          });
          peersSet.forEach(graftPeer);
        } // do we have to many peers?


        if (peers.size > Dhi) {
          var peersArray = Array.from(peers); // sort by score

          peersArray.sort(function (a, b) {
            return getScore(b) - getScore(a);
          }); // We keep the first D_score peers by score and the remaining up to D randomly
          // under the constraint that we keep D_out peers in the mesh (if we have that many)

          peersArray = peersArray.slice(0, Dscore).concat(utils_1.shuffle(peersArray.slice(Dscore))); // count the outbound peers we are keeping

          var outbound = 0;
          peersArray.slice(0, D).forEach(function (p) {
            if (_this2.gossipsub.outbound.get(p)) {
              outbound++;
            }
          }); // if it's less than D_out, bubble up some outbound peers from the random selection

          if (outbound < Dout) {
            var rotate = function rotate(i) {
              // rotate the peersArray to the right and put the ith peer in the front
              var p = peersArray[i];

              for (var j = i; j > 0; j--) {
                peersArray[j] = peersArray[j - 1];
              }

              peersArray[0] = p;
            }; // first bubble up all outbound peers already in the selection to the front


            if (outbound > 0) {
              var ihave = outbound;

              for (var i = 1; i < D && ihave > 0; i++) {
                if (_this2.gossipsub.outbound.get(peersArray[i])) {
                  rotate(i);
                  ihave--;
                }
              }
            } // now bubble up enough outbound peers outside the selection to the front


            var _ineed = D - outbound;

            for (var _i = D; _i < peersArray.length && _ineed > 0; _i++) {
              if (_this2.gossipsub.outbound.get(peersArray[_i])) {
                rotate(_i);
                _ineed--;
              }
            }
          } // prune the excess peers


          peersArray.slice(D).forEach(prunePeer);
        } // do we have enough outbound peers?


        if (peers.size >= Dlo) {
          // count the outbound peers we have
          var _outbound = 0;
          peers.forEach(function (p) {
            if (_this2.gossipsub.outbound.get(p)) {
              _outbound++;
            }
          }); // if it's less than D_out, select some peers with outbound connections and graft them

          if (_outbound < Dout) {
            var _ineed2 = Dout - _outbound;

            var _backoff = _this2.gossipsub.backoff.get(topic);

            get_gossip_peers_1.getGossipPeers(_this2.gossipsub, topic, _ineed2, function (id) {
              // filter our current mesh peers, direct peers, peers we are backing off, peers with negative score
              return !peers.has(id) && !_this2.gossipsub.direct.has(id) && (!_backoff || !_backoff.has(id)) && getScore(id) >= 0;
            }).forEach(graftPeer);
          }
        } // should we try to improve the mesh with opportunistic grafting?


        if (_this2.gossipsub.heartbeatTicks % constants.GossipsubOpportunisticGraftTicks === 0 && peers.size > 1) {
          // Opportunistic grafting works as follows: we check the median score of peers in the
          // mesh; if this score is below the opportunisticGraftThreshold, we select a few peers at
          // random with score over the median.
          // The intention is to (slowly) improve an underperforming mesh by introducing good
          // scoring peers that may have been gossiping at us. This allows us to get out of sticky
          // situations where we are stuck with poor peers and also recover from churn of good peers.
          // now compute the median peer score in the mesh
          var peersList = Array.from(peers).sort(function (a, b) {
            return getScore(a) - getScore(b);
          });
          var medianIndex = Math.floor(peers.size / 2);
          var medianScore = getScore(peersList[medianIndex]); // if the median score is below the threshold, select a better peer (if any) and GRAFT

          if (medianScore < _this2.gossipsub._options.scoreThresholds.opportunisticGraftThreshold) {
            var _backoff2 = _this2.gossipsub.backoff.get(topic);

            var peersToGraft = get_gossip_peers_1.getGossipPeers(_this2.gossipsub, topic, constants.GossipsubOpportunisticGraftPeers, function (id) {
              // filter out current mesh peers, direct peers, peers we are backing off, peers below or at threshold
              return peers.has(id) && !_this2.gossipsub.direct.has(id) && (!_backoff2 || !_backoff2.has(id)) && getScore(id) > medianScore;
            });
            peersToGraft.forEach(function (id) {
              _this2.gossipsub.log('HEARTBEAT: Opportunistically graft peer %s on topic %s', id, topic);

              graftPeer(id);
            });
          }
        } // 2nd arg are mesh peers excluded from gossip. We have already pushed
        // messages to them, so its redundant to gossip IHAVEs.


        _this2.gossipsub._emitGossip(topic, peers);
      }); // expire fanout for topics we haven't published to in a while

      var now = this.gossipsub._now();

      this.gossipsub.lastpub.forEach(function (lastpb, topic) {
        if (lastpb + fanoutTTL < now) {
          _this2.gossipsub.fanout.delete(topic);

          _this2.gossipsub.lastpub.delete(topic);
        }
      }); // maintain our fanout for topics we are publishing but we have not joined

      this.gossipsub.fanout.forEach(function (fanoutPeers, topic) {
        // checks whether our peers are still in the topic and have a score above the publish threshold
        var topicPeers = _this2.gossipsub.topics.get(topic);

        fanoutPeers.forEach(function (id) {
          if (!topicPeers.has(id) || getScore(id) < _this2.gossipsub._options.scoreThresholds.publishThreshold) {
            fanoutPeers.delete(id);
          }
        }); // do we need more peers?

        if (fanoutPeers.size < D) {
          var ineed = D - fanoutPeers.size;
          var peersSet = get_gossip_peers_1.getGossipPeers(_this2.gossipsub, topic, ineed, function (id) {
            // filter out existing fanout peers, direct peers, and peers with score above the publish threshold
            return !fanoutPeers.has(id) && !_this2.gossipsub.direct.has(id) && getScore(id) >= _this2.gossipsub._options.scoreThresholds.publishThreshold;
          });
          peersSet.forEach(function (id) {
            fanoutPeers.add(id);
          });
        } // 2nd arg are fanout peers excluded from gossip.
        // We have already pushed messages to them, so its redundant to gossip IHAVEs


        _this2.gossipsub._emitGossip(topic, fanoutPeers);
      }); // send coalesced GRAFT/PRUNE messages (will piggyback gossip)

      this.gossipsub._sendGraftPrune(tograft, toprune, noPX); // flush pending gossip that wasn't piggybacked above


      this.gossipsub._flush(); // advance the message history window


      this.gossipsub.messageCache.shift();
      this.gossipsub.emit('gossipsub:heartbeat');
    }
  }]);

  return Heartbeat;
}();

exports.Heartbeat = Heartbeat;